import * as Yup from "yup";
import REGEXS from "../utils/regex";

export const addDoctorSchema = Yup.object().shape({
    doctor_name: Yup.string()
        .required("Name is required")
        .matches(REGEXS.name, "Name should contain only alphabets and spaces")
        .min(3, "Name must be at least 3 characters")
        .max(100, "Name must not exceed 100 characters"),

    designation: Yup.string()
        .matches(REGEXS.name, "Specialization should contain only alphabets and spaces")
        .max(100, "Specialization must not exceed 100 characters"),

    training_status: Yup.string()
        .required("Training completed is required"),

    phone_number: Yup.string()
        .required("Mobile number is required")
        .matches(REGEXS.mobile, "Please enter a valid 10-digit mobile number"),

    email: Yup.string()
        .required("Email is required")
        .matches(REGEXS.email, "Please enter a valid email address"),

    hpr_id: Yup.string()
        .matches(REGEXS.alplabhetNumericWithSpecial, "HPR ID contains invalid characters"),

    reg_number: Yup.string()
        .matches(REGEXS.alplabhetNumericWithSpecial, "Registration number contains invalid characters"),

    reg_year: Yup.number()
        .nullable()
        .transform((value, originalValue) => originalValue === "" ? null : value)
        .min(1900, "Invalid year")
        .max(new Date().getFullYear(), "Year cannot be in the future")
        .typeError("Registration year must be a number"),

    state_lgd: Yup.number()
        .nullable()
        .transform((value, originalValue) => originalValue === "" ? null : value)
        .typeError("Please select a valid state"),

    insource_outsource: Yup.string()
        .oneOf(["Insource", "Outsource"], "Invalid posting type"),

    visiting_from: Yup.string()
        .when("insource_outsource", {
            is: "Outsource",
            then: (schema) => schema
                .matches(REGEXS.alplabhetNumericWithSpecial, "Visiting from contains invalid characters"),
            otherwise: (schema) => schema.notRequired(),
        }),
});